module.exports = __webpack_public_path__ + "img/tally.efbc7816.jpg";